import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function Login() {
  const authError = new URLSearchParams(window.location.search).get("auth_error");

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-sm">
        <CardContent className="space-y-6 p-8 text-center">
          <div>
            <div className="mx-auto mb-3 flex size-14 items-center justify-center rounded-2xl bg-primary text-2xl text-primary-foreground">
              ♥
            </div>
            <h1 className="text-2xl font-bold">FamilyLife</h1>
            <p className="mt-1 text-sm text-muted-foreground">Your household, in one place.</p>
          </div>

          {authError && (
            <p className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">
              Sign-in failed ({authError}). Please try again.
            </p>
          )}

          <a href="/auth/google/login" className="block">
            <Button className="w-full gap-2" size="lg">
              <GoogleIcon /> Sign in with Google
            </Button>
          </a>
        </CardContent>
      </Card>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-4" aria-hidden>
      <path fill="currentColor" d="M21.35 11.1H12v2.92h5.35c-.23 1.24-.94 2.29-2 3l3.23 2.5c1.89-1.74 2.98-4.3 2.98-7.35 0-.66-.06-1.3-.21-1.07z" />
      <path fill="currentColor" d="M12 22c2.7 0 4.96-.9 6.62-2.42l-3.23-2.5c-.9.6-2.05.96-3.39.96-2.6 0-4.8-1.76-5.59-4.13H3.06v2.6A9.99 9.99 0 0 0 12 22z" />
      <path fill="currentColor" d="M6.41 13.91A6 6 0 0 1 6.09 12c0-.66.11-1.31.32-1.91V7.49H3.06A9.99 9.99 0 0 0 2 12c0 1.61.39 3.14 1.06 4.51l3.35-2.6z" />
      <path fill="currentColor" d="M12 6.04c1.47 0 2.79.51 3.83 1.5l2.87-2.87C16.95 2.99 14.7 2 12 2A9.99 9.99 0 0 0 3.06 7.49l3.35 2.6C7.2 7.8 9.4 6.04 12 6.04z" />
    </svg>
  );
}
